// extracted by mini-css-extract-plugin
export default {"customized-column-width":"PastPayments_customized-column-width__NOwk4","download-link":"PastPayments_download-link__QhYc0"};